import React from 'react';
import './App.css';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { ethers } from "ethers";
import Web3Modal from "web3modal";
import { Typography } from '@mui/material';
import img from "./pulsar.svg"
const ABI = require("./ABI.json")
const ERC20ABI = require("./ERC20ABI.json")

const chainInfo = process.env.REACT_APP_MAINNET === "true" ? 
{
  settings: {
    chainId: 9001,
    chainName: "Evmos",
    nativeCurrency: {
      name: "EVMOS",
      symbol: "EVMOS",
      decimals: 18,
    },
    rpcUrls: ["https://eth.bd.evmos.org:8545"],
    blockExplorerUrls: ["https://evm.evmos.org"],
  },
} : {
  settings: {
    chainId: "0x2328",
    chainName: "Evmos Testnet",
    nativeCurrency: {
      name: "tEVMOS",
      symbol: "tEVMOS",
      decimals: 18,
    },
    rpcUrls: ["https://eth.bd.evmos.dev:8545"],
    blockExplorerUrls: ["https://evm.evmos.dev"],
  },
};


function App() {
  const [addresses, setAddresses] = React.useState("");
  const [tokenAddress, setTokenAddress] = React.useState("");
  const [tokenInfo, setTokenInfo] = React.useState({} as any);
  const [error, setError] = React.useState("");
  const [errorToken, setTokenError] = React.useState("");
  const [loading, setLoading] = React.useState(false);
    const x = async () => { 
      setLoading(true);
      try {
        const providerOptions = {
        };

        const web3Modal = new Web3Modal({
          cacheProvider: true, 
          providerOptions
        });

        const instance = await web3Modal.connect();

        const provider = new ethers.providers.Web3Provider(instance);
        try {
          if (provider && provider.provider && provider.provider.request) {
          await provider.provider.request({
            method: "wallet_addEthereumChain",
            params: [chainInfo.settings],
          });
        }
        } catch (err) {
          // eslint-disable-next-line
        }
        // return null;
    
        const lines = addresses.split("\n").filter((line) => line.length > 0);
        console.log({lines}, "lines", addresses)
        const addressesClean = lines.map(e=> e.split(/,|\s|;]/))
        .filter((part: any) => part.length > 0)
        .map(e=> e[0]);
        console.log(addressesClean, "cleaned")
        const amounts = lines.map(e => e.split(/,|\s|;]/))
        .filter((part: any) => part.length > 0)
        .map(e=> ethers.utils.parseEther(e[1]));
        const total = amounts.reduce((a:any,b:any) => a.add(b), ethers.constants.Zero);
        console.log(Number(total), "total", amounts)
        const signer = provider.getSigner();
        const contract = new ethers.Contract(process.env.REACT_APP_SMARTCONTRACT_ADDRESS!, ABI, signer);

        if (tokenAddress) {
          const tokenContract = new ethers.Contract(tokenAddress, ERC20ABI, signer);
          const allowed = await tokenContract.allowance(await signer.getAddress(), contract.address)
          if (allowed.lt(total) ) {
            const trx = await tokenContract.approve(contract.address, total);
            await trx.wait();
          } else {
            console.log("already allowed")
          }
          console.log(contract ,tokenAddress, addressesClean, amounts)
          await contract.multiSendToken(tokenAddress, addressesClean, amounts)
        }

      } catch (err:any) {
        console.log(err?.message,"err")
      } finally {
        setLoading(false);
      }
    }

  const checkIsAddressesOnly = (addresses: string) => {
    const lines = addresses.split("\n").filter((line) => line.length > 0);
    if (lines.length > 500) {
      setError("Too many addresses (max 500)");
      return false;
    }
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].trim();
      const parts = line.split(/,|\s|;]/).filter((part) => part.length > 0);
      if (!ethers.utils.isAddress(parts[0])) {
        setError(`Line ${i + 1} is not a valid address`);
        return 
      }
      if (parts.length !== 2) {
        setError(`Line ${i + 1} is not a valid address value pair`);
        return 
      }
      try {
        ethers.utils.parseEther(parts[1]);
      }
      catch (err) {
        setError(`Line ${i + 1} is not a valid ether value`);
        return 
      }
    }
    setError("");
  
  }
  const getTokenInfo = async (address: string) => {
    const provider = new ethers.providers.JsonRpcProvider(chainInfo.settings.rpcUrls[0]);
    const contract = new ethers.Contract(address, ERC20ABI, provider);
    const symbol = await contract.symbol();
    const decimal = await contract.decimals();
    const name = await contract.name();
    setTokenInfo({symbol, decimal, name});
  }

  return (
    <div className="App">
      <header className="App-header" 
      style={{
        backgroundRepeat: "no-repeat", 
        backgroundImage: `url(${img})`,
        backgroundSize: "cover"}}>
        
        <Typography style={{fontSize: 50, fontWeight: "bold", color: "black"}}>Enter EVMOS token address</Typography>
        <TextField value={tokenAddress} onChange={async (e) => {
            setTokenError("");
          const clean = e.target.value.trim()
          if (clean.length === 0) {
            setTokenAddress("")
            setTokenInfo({})
            
            return
          }
          setTokenAddress(clean);

          if (!ethers.utils.isAddress(clean)) {
            setTokenError("Not a valid address");
            setTokenInfo({})
            return
          }
          try {
            await getTokenInfo(clean);

          } catch (err) {
            console.log(err);
            setTokenError("Can't get token info, is it a valid token?");
          }

        }}
        error={!!errorToken.length}
        helperText={errorToken}
        style={{backgroundColor: "white", minWidth: "50%", maxWidth: 500, opacity: "0.8"}}
        />
        {tokenInfo?.decimal ? <Typography  style={{fontSize: 50, fontWeight: "bold", color: "black"}}>Send {tokenInfo.name} ({tokenInfo.symbol}) decimal ({tokenInfo.decimal}) </Typography> : null}

        <Typography style={{marginTop: 30, fontSize: 30, fontWeight: "bold", color: "black"}}>Enter one address per line followed by a space and the amount</Typography>
        <TextField
          style={{backgroundColor: "white", minWidth: "50%", maxWidth: 500, opacity: "0.8"}}
          value={addresses}
          onChange={e=> {
            checkIsAddressesOnly(e.target.value);
            setAddresses(e.target.value)
          }}
          error={error.length > 0}
          helperText={error}
          multiline
          rows={10}
        />
        <Button disabled={!!error || !addresses || !!errorToken || !tokenAddress || !tokenInfo?.decimal || loading}
         variant="contained" color="primary" onClick={x}>
          send
        </Button>
      </header>
    </div>
  );
}

export default App;
